export default {"src":"/_next/static/media/playStoreWhite.1e565680.svg","height":48,"width":162};